module.exports = __webpack_public_path__ + "media/images/JDRF_logo-68496458b9f4475d64e98e0b6a3b8dfd.png";